import React from 'react'
import { RefreshCw } from 'lucide-react'
import { formatUsaDateTime } from '../../lib/usaGreeting'
import { formatRelativeTime } from './overviewFormat'

/**
 * @param {{
 *   greetingText: string
 *   roleLabel: string
 *   isAdminUser: boolean
 *   moduleCount: number
 *   loading: boolean
 *   asOfIso: string | null
 *   onRefresh: () => void
 *   refreshDisabled?: boolean
 * }} props
 */
export default function OverviewHero({
  greetingText,
  roleLabel,
  isAdminUser,
  moduleCount,
  loading,
  asOfIso,
  onRefresh,
  refreshDisabled,
}) {
  const updatedLabel = asOfIso ? `As of ${formatRelativeTime(asOfIso)}` : ''

  return (
    <header className="overview-hero overview-fade-in">
      <div className="overview-hero-main">
        <p className="overview-brand-line">
          <span className="overview-brand-mark">SMG</span>
          <span className="overview-brand-sep">·</span>
          <span>Smart Media Group</span>
        </p>
        <h1 className="overview-hero-title">{greetingText}</h1>
        <p className="overview-hero-meta">
          <span
            className={`overview-role-pill${isAdminUser ? ' overview-role-pill--admin' : ''}`}
          >
            {roleLabel}
          </span>
          <span className="overview-hero-modules">
            {moduleCount} module{moduleCount === 1 ? '' : 's'} in your workspace
          </span>
        </p>
      </div>
      <div className="overview-hero-aside">
        <div className="overview-datetime">{formatUsaDateTime()}</div>
        <div className="overview-action-bar overview-action-bar--inline">
          <button
            type="button"
            className="overview-btn-secondary"
            disabled={loading || refreshDisabled}
            onClick={onRefresh}
            aria-label="Refresh dashboard"
          >
            <RefreshCw size={14} className="overview-btn-icon" aria-hidden />
            {loading ? 'Refreshing…' : 'Refresh'}
          </button>
          {updatedLabel ? <span className="overview-freshness">{updatedLabel}</span> : null}
        </div>
      </div>
    </header>
  )
}
